import React, { useState } from 'react';
import Login from './Login';
import Signup from './Signup';

const Auth = ({ theme, toggleTheme }) => {
  const [view, setView] = useState('login'); 

  const toggleView = (newView) => {
    setView(newView);
  };

  return (
    <div>
      {view === 'login' ? (
        <Login toggleView={toggleView} theme={theme} toggleTheme={toggleTheme} />
      ) : (
        <Signup toggleView={toggleView} theme={theme} toggleTheme={toggleTheme} />
      )}
    </div>
  );
};

export default Auth;
